import { useQuery } from "@tanstack/react-query";
import { useUser } from "../../../contexts/UserContext";
import { useFamily } from "../../../domain/services/hooks/useFamily";
import { useFamilyBankAccounts } from "../../../domain/services/hooks/useFamilyBankAccounts";

export const useFamilyMetrics = () => {
  const { currentUser } = useUser();
  const { family } = useFamily();
  const { familyBankAccounts } = useFamilyBankAccounts();

  const accountsKey = JSON.stringify(
    Object.keys(familyBankAccounts || {}).map((userId) => ({
      userId,
      accountIds: familyBankAccounts[userId]?.map((acc) => acc.accountId),
    })),
  );

  return useQuery({
    queryKey: ["familyMetrics", currentUser?.uid, accountsKey],
    queryFn: async () => {
      const activeMemberCount = family?.members?.length || 1;
      const totalAccounts = Object.values(familyBankAccounts || {}).flat()
        .length;

      return {
        activeMemberCount,
        totalAccounts,
      };
    },
    enabled: !!currentUser?.uid && !!family && !!familyBankAccounts,
  });
};
